import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, Typography, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Page5 = () => {
  const [hasBeenHovered, setHasBeenHovered] = useState(false);
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    fullName: "",
    companyName: "",
    email: "",
  });

  const sectionRef = useRef(null);
  const navigate = useNavigate();

  // IntersectionObserver for animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.3) {
          setHasBeenHovered(true);
        }
      },
      { threshold: [0.3] }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const validateForm = () => {
    let formIsValid = true;
    const newErrors = {
      fullName: "",
      companyName: "",
      email: "",
    };

    if (!fullName.trim()) {
      newErrors.fullName = "Please enter your full name.";
      formIsValid = false;
    }
    if (!companyName.trim()) {
      newErrors.companyName = "Please enter your company name.";
      formIsValid = false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleJoinClick = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch("http:///backend.towerwatch.io/api/waiting_list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: fullName,
          companyName: companyName,
          email: email,
        }),
      });

      if (response.ok) {
        navigate("/Page6", { 
          state: { 
            fullName, 
            companyName, 
            email 
          } 
        });
      } else {
        const errorData = await response.json();
        alert(errorData.message || "Failed to join the waiting list.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error connecting to the server.");
    }
  };
  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy');
  };

  return (
    <Box
    ref={sectionRef}
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
      height: { xs: '100vh', sm: '120vh' }, // Adjust based on screen size
      backgroundColor: '#000',
      color: '#fff',
      padding: { xs: '0 5%', sm: '0 10%' },
      cursor: 'pointer',
      position: 'relative',
    }}
  >
      <Box
        sx={{
          position: 'absolute',
          top: 10,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#1A1A1A',
          zIndex: 0 ,
          width: '100%',
          height: '185px',
          marginTop: '85px',
          opacity: hasBeenHovered ? 1 : 0,
          transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
          transition: "all 0.6s ease-out",
          
        }}
      />
      <Box
  sx={{
    position: "absolute",
    top: 10,
    left: 0,
    right: 0,
    bottom: 0,
    height: "2px",
    width: "100%", // Adjust width as needed
    background: "linear-gradient(to right, #000000 0%, #C3835F 50%, #000000 100%)",
    marginTop:'85px',
     opacity: hasBeenHovered ? 1 : 0,
    transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
    transition: "all 0.6s ease-out",
  }}
/>
<Box
  sx={{
    position: "absolute",
    top: 10,
    left: 0,
    right: 0,
    bottom: 0,
    height: "2px",
    width: "100%", // Adjust width as needed
    background: "linear-gradient(to right, #000000 0%, #C3835F 50%, #000000 100%)",
    marginTop:'269px',
     opacity: hasBeenHovered ? 1 : 0,
    transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
    transition: "all 0.6s ease-out",
  }}
/>

      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          opacity: hasBeenHovered ? 1 : 0,
          transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
          transition: "all 0.6s ease-out",
          marginTop:'127px'
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: '24px', sm: '32px' },
            fontFamily: "Raleway",
            color: "#7A7A7A",
            fontWeight: 300,
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.6s",
            marginBottom:'5px',
            marginTop:'-30px'
          }}
        >
          Coming Soon
        </Typography>

        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '32px', sm: '48px' },
            fontFamily: "Raleway",
            color: "#FFFFFF",
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.8s",
            fontWeight: 400,
            lineHeight: "1.2",
          }}
        >
          Get <Box component="span" sx={{ color: "#00bfff" }}>Notified</Box>
          <br />
          When We Launch
        </Typography>
      </Grid>
      <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        opacity: hasBeenHovered ? 1 : 0,
        transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
        transition: "all 0.6s ease-out",
      }}
    >
        <Typography
        variant="h1"
        sx={{
          fontSize: "20px",
          fontFamily: "Raleway",
          color: "#FFFFFF",
          opacity: hasBeenHovered ? 1 : 0,
          transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
          transition: "all 0.6s ease-out 0.8s",
          fontWeight: 400,
          lineHeight: "1.2",
          textAlign:'center',
          marginTop:'auto',
          //marginBottom:'0px'
        }}
      >
        Sign up now to stay ahead and help build a greener tomorrow! Be the first to know when we launch.
      </Typography>
      </Grid>

      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          opacity: hasBeenHovered ? 1 : 0,
          transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
          transition: "all 0.6s ease-out 1.2s",
          
        }}
      ></Grid>
      <form 
        onSubmit={handleJoinClick}
        sx={{ width: '100%', maxWidth: '400px',position: 'relative',top: '-90px' }}	
      >
        {/* Full Name Field */}
        <Grid
          item
          sx={{
            position: "relative",
            width: "100%",
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 1.4s",
            mb: 4,
            fontFamily: "Raleway"
          }}
        >
          <TextField
            fullWidth
            variant="standard"
            label="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            error={!!errors.fullName}
            helperText={errors.fullName}
            sx={{
                '& .MuiInputBase-input': {
                color: 'white', 
                WebkitTextFillColor: 'white', // Ensures visibility in webkit browsers
                opacity: 1, 
              },  
              '& .MuiInputLabel-standard': {
                color: '#7A7A7A',
                transition: 'color 0.3s ease'
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: '#7A7A7A'
              },
              '& .MuiInput-underline:after': {
                borderBottomColor: '#B67652'
              }
            }}
          />
        </Grid>

        {/* Company Name Field */}
        <Grid
          item
          sx={{
            position: "relative",
            width: "100%",
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 1.6s",
            mb: 4,
            fontFamily: "Raleway"
          }}
        >
          <TextField
            fullWidth
            variant="standard"
            label="Company Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            error={!!errors.companyName}
            helperText={errors.companyName}
            sx={{
                '& .MuiInputBase-input': {
                color: 'white', 
              },  
              '& .MuiInputLabel-standard': {
                color: '#7A7A7A',
                transition: 'color 0.3s ease'
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: '#7A7A7A'
              },
              '& .MuiInput-underline:after': {
                borderBottomColor: '#B67652'
              }
            }}
          />
        </Grid>

        {/* Email Address Field */}
        <Grid
          item
          sx={{
            position: "relative",
            width: "100%",
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 1.8s",
            mb: 4,
            fontFamily: "Raleway"
          }}
        >
          <TextField
            fullWidth
            variant="standard"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            sx={{
              '& .MuiInputBase-input': {
                color: 'white', 
              },    
              '& .MuiInputLabel-standard': {
                color: '#7A7A7A',
                transition: 'color 0.3s ease'
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: '#7A7A7A'
              },
              '& .MuiInput-underline:after': {
                borderBottomColor: '#B67652'
              }
            }}
          />
        </Grid>

        <button
          type="submit"
          style={{
            backgroundColor: "transparent",
            border: "1px solid #fff",
            color: "#fff",
            fontSize: "10px",
            fontWeight: "regular",
            width: "100%",
            maxWidth: "267px",
            height: "38px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: '100px',
            marginTop:'60px',
            fontFamily: "Raleway",
            cursor: "pointer",
            borderRadius:'15px',
            opacity: hasBeenHovered ? 1 : 0,
            transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 1.8s",
          }}
        >
          Join the Waiting List
        </button>
        {/* Container for LinkedIn and Privacy Policy */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: { xs: "15px", sm: "20px" }, // Smaller gap on mobile
            marginBottom: '60px',
          }}
        >
          <Typography
            component="a"
            href="https://www.linkedin.com/company/towerwatch/posts/?feedView=all"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: '#7A7A7A',
              fontSize: { xs: '12px', sm: '14px' }, // Smaller font on mobile
              fontFamily: 'Raleway',
              textDecoration: 'underline',
              opacity: hasBeenHovered ? 1 : 0,
              transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
              transition: "all 0.6s ease-out 2s",
              '&:hover': { color: '#B67652' },
            }}
          >
            LinkedIn
          </Typography>

          <Typography
            component="span"
            onClick={handlePrivacyPolicyClick}
            sx={{
              color: '#7A7A7A',
              fontSize: { xs: '12px', sm: '14px' }, // Smaller font on mobile
              fontFamily: 'Raleway',
              textDecoration: 'underline',
              opacity: hasBeenHovered ? 1 : 0,
              transform: hasBeenHovered ? "translateY(0)" : "translateY(20px)",
              transition: "all 0.6s ease-out 2s",
              '&:hover': { color: '#B67652' },
              cursor: "pointer",
            }}
          >
            Privacy Policy
          </Typography>
        </Box>
      </form>
    </Box>
  );
};

export default Page5;
